import { createUseStyles } from 'react-jss'

import { COLOR, Z_INDEX, MQ, TYPOGRAPHY } from 'utils/constants'

export const useStyles = createUseStyles({
  headerWrapper: {
    backgroundColor: COLOR.WHITE,
  },
  headerContainer: {
    width: '88%',
    margin: 'auto',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: 125,
    [MQ.TABLET]: {
      maxWidth: 650,
      margin: [0, 0, 0, '5.14%'],
      justifyContent: 'flex-start',
    },
    [MQ.DESKTOP]: {
      minHeight: 210,
      maxWidth: 640,
    },
  },
  headerLink: {
    color: COLOR.BLACK,
    textDecoration: 'none',
    lineHeight: '100%',
    margin: [0, 17, 0],
    padding: [20, 0],
    textTransform: 'uppercase',
    [MQ.TABLET]: {
      color: COLOR.DARK_GREEN,
    },
    '& span': {
      letterSpacing: '0.08em',
    },
    '&:hover': {
      color: COLOR.DARK_GREEN,
      '&:active': {
        color: COLOR.DARK_GREEN,
      },
    },
  },
  navContainer: {
    display: 'none',
    alignItems: 'center',
    flexWrap: 'wrap',
    [MQ.TABLET]: {
      display: 'flex',
      marginLeft: 50,
    },
    [MQ.DESKTOP]: {
      marginLeft: 10,
    },
    [`@media (min-width: 1375px)`]: {
      marginLeft: 50,
    },
  },
  logoContainer: {
    width: 110,
    height: 110,
    '& div': {
      width: '100%',
      height: '100%',
    },
    [MQ.TABLET]: {
      width: 110,
      height: 110,
    },
    [MQ.DESKTOP]: {
      width: 120,
      height: 120,
    },
  },
  button: {
    border: `4px solid ${COLOR.LIGHT_GREEN}`,
    borderRadius: 118,
    padding: [18, 26, 16],
    '&:hover': {
      backgroundColor: COLOR.LIGHT_GREEN,
      '& span': {
        color: COLOR.WHITE,
      },
      '&:active': {
        backgroundColor: COLOR.DARK_GREEN,
        border: `4px solid ${COLOR.DARK_GREEN}`,
      },
    },
  },

  sideNavLink: {
    color: COLOR.WHITE,
    border: 'none',
    padding: [10, 0],
    margin: 0,
    [MQ.TABLET]: {
      padding: [15, 0],
    },
  },
  buttonMobile: {
    color: COLOR.DARK_GREEN,
  },
  heightBroke: {
    display: 'none',
  },
  menuButton: {
    outline: 'none',
    background: 'rgba(0, 0, 0, 0)',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    height: 26,
    '&::before': {
      content: `''`,
      backgroundColor: COLOR.DARK_GREEN,
      width: 35,
      height: 3,
      transition: 'all 0.2s ease',
    },
  },
  lines: {
    width: 35,
    height: 26,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    position: 'absolute',
    '&::before': {
      content: `''`,
      backgroundColor: COLOR.DARK_GREEN,
      width: 35,
      height: 3,
      transition: 'all 0.2s ease',
    },
    '&::after': {
      content: `''`,
      backgroundColor: COLOR.DARK_GREEN,
      width: 35,
      height: 3,
      transition: 'all 0.2s ease',
    },
  },
  menuButtonOpen: {
    zIndex: Z_INDEX.MODAL,
    '&::before': {
      content: `''`,
      backgroundColor: 'rgba(0, 0, 0, 0)',
      transition: 'all 0.2s ease',
    },
  },
  linesOpen: {
    '&::before': {
      transform: 'translateY(10px) rotate(-45deg)',
      backgroundColor: COLOR.WHITE,
    },
    '&::after': {
      transform: 'translateY(-12px) rotate(45deg)',
      backgroundColor: COLOR.WHITE,
    },
  },
  sideNav: {
    position: 'fixed',
    right: '-100vw',
    width: '100vw',
    height: '100vh',
    overflowY: 'scroll',
    backgroundColor: COLOR.LIGHT_GREEN,
    transition: 'all 0.3s ease',
    zIndex: Z_INDEX.NAV,
    top: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  sideNavOpen: {
    right: 0,
    transition: 'all 0.3s ease',
  },
  mobileLinksWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: [165, 0, 100],
  },
  headroom: {
    zIndex: Z_INDEX.NAV,
  },
  logo: {
    width: 151,
    height: 56,
  },
  cart: {
    width: 35,
    height: 35,
    position: 'absolute',
    top: 52,
    left: '6%',
    [MQ.TABLET]: {
      top: 'auto',
      left: 'auto',
      width: 25,
      height: 25,
      right: '5.14%',
    },
  },
  cartLink: {
    position: 'relative',
  },
  cartAmount: {
    ...TYPOGRAPHY.PROXIMA_NOVA,
    textDecoration: 'none',
    position: 'absolute',
    left: 25,
    top: -7.5,
    backgroundColor: COLOR.DARK_GREEN,
    borderRadius: '50%',
    width: 24,
    height: 24,
    fontSize: 12,
    color: COLOR.WHITE,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: Z_INDEX.CONTENT,
    [MQ.TABLET]: {
      fontSize: 10,
      left: 15,
      top: -7.5,
      width: 20,
      height: 20,
    },
  },
  hidden: {
    display: 'none',
  },
  hiddenText: {
    position: 'absolute',
    left: '-200vw',
  },
})
